export const METAL_DIVIDE_ALL = 'METAL_DIVIDE_ALL';
export const METAL_DIVIDE_GET = 'METAL_DIVIDE_GET';
export const METAL_DIVIDE_POST = 'METAL_DIVIDE_POST';
export const METAL_DIVIDE_PUT = 'METAL_DIVIDE_PUT';
export const METAL_DIVIDE_DELETE = 'METAL_DIVIDE_DELETE';
export const METAL_DIVIDE_LOADING = 'METAL_DIVIDE_LOADING';
export const METAL_DIVIDE_ERROR = 'METAL_DIVIDE_ERROR';
